module.exports = __webpack_public_path__ + "img/chevron-left-double.f46d9804.svg";